module.exports = __webpack_public_path__ + "img/4.55ae6b04.png";